import PropTypes from 'prop-types';
import fr from 'facet-rest';
import React from 'react';
import { ProposalInflowsSectionContainer } from 'Organisms/ProposalInflowsSection';

const ScenarioSelectionRedefinedAllocatableResourcesLayout = ({
  resource,
}) => {
  return resource.withRelationship(
    fr.relationships.proposalYearAheadInflowSection.name,
    (rel) => (
      <ProposalInflowsSectionContainer relationship={rel.link('related')} />
    ),
    () => null,
  );
};

ScenarioSelectionRedefinedAllocatableResourcesLayout.defaultProps = {
};

ScenarioSelectionRedefinedAllocatableResourcesLayout.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default ScenarioSelectionRedefinedAllocatableResourcesLayout;
